import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Button } from "react-bootstrap";
import {
  Page,
  ImagePreview,
  DetailShipmentCard,
} from "ui/components";

import { Schedule } from "services/action";

import cn from "classnames";

import { formatDate } from "utilities/common";
import { currencyFormat } from "utilities/common";


const HistoryReportScreen = ({match, location}) => {
  const History = useHistory();
  const Dispatch = useDispatch();
  const [data, setData] = React.useState(null);

  const { tap_in, tap_out } = location?.state;

  const $onLoad = async (id) => {
    const req = await Dispatch(Schedule.$showReport(id));

    if (req?.message === "success") {
      if (req?.data !== null) {
        setData(req?.data);
      }
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, [match?.params?.id]);

  const ListHorizontal = ({ title, content, className }) => {
    const c = cn(
      className ? className : "",
      "row py-1 mb-1 list-item m-0 align-items-start fsz-12 border-bottom"
    );

    return (
      <div className={c}>
        <div className="col-4 p-0 fsz-12 text-capitalize">{title}</div>
        <div className="col-1 p-0 fsz-12">:</div>
        <div className="col-7 p-0 text-start title fsz-12 fw-semibold">{content}</div>
      </div>
    );
  };

  return (
    <Page
      title={`Detail Absence`}
      backTo={() => History.goBack()}
      action={
        <div>
          {data?.status !== "approved" && (
            <Button
              type="button"
              variant="primary"
              className="pe-4 ps-4 rounded w-100 text-capitalize fs-7"
              onClick={() =>
                History.push({
                  pathname: "/schedule/update",
                  state: {
                    data: data,
                  },
                })
              }
            >
              Perbaharui
            </Button>
          )}
        </div>
      }
    >
      <div className="py-2 pb-5">
        <DetailShipmentCard title="Informasi Absense">
          <ListHorizontal
            title="Schedule"
            content={formatDate(data?.schedule_date, 'DD/MM/YYYY')}
          />
          <ListHorizontal
            title="Clockin"
            content={formatDate(tap_in, 'DD/MM/YYYY HH:mm')}
          />

          <ListHorizontal
            title="Clockout"
            content={tap_out === '0001-01-01T00:00:00Z' ? '-' : formatDate(tap_out, 'DD/MM/YYYY HH:mm')}
          />

          <ListHorizontal
            title="KM Awal"
            content={currencyFormat(data?.document?.start_odo)}
          />

          <ListHorizontal
            title="KM Akhir"
            content={data?.document?.end_odo ? currencyFormat(data?.document?.end_odo) : '-'}
          />

          {data?.document?.receipts?.map((i) => (
            <>
              {i?.type !== 'start_odo' && i?.type !== 'end_odo' && (
                <ListHorizontal
                  title={i?.type}
                  content={currencyFormat(i?.nominal)}
                />
              )}
            </>
          ))}

          <ListHorizontal
            title="Uang Jalan"
            content={data?.document?.total_receipt ? currencyFormat(data?.document?.total_receipt) : '-'}
          />
        </DetailShipmentCard>

        <div className="rounded-2 border-3" style={{ backgroundColor: "rgba(59, 59, 59, 0.1)" }}>
          <div className="px-2 py-2 fsz-12 fw-bold" >Infomation Dokumen</div>

          {data?.document?.receipts?.map((i, k) => (
            <div key={k} className="border-bottom px-2 py-2 bg-white ">
              <span className='text-capitalize'>{i?.type?.replace('start_odo', 'KM Awal')?.replace('end_odo', 'Km Akhir')}</span>
              <ImagePreview images={i?.images} />
            </div>
          ))}
        </div>
      </div>
    </Page>
  );
};

export default HistoryReportScreen;
